<template>
  <div class="icon-data">
    <div
      class="icon-box"
      :style="{backgroundColor:iconOuterColor,color:iconColor}"
    >
      <ig-icon :name="iconName"></ig-icon>
    </div>
    <div class="label-value">
      <div class="label">{{label}}</div>
      <div class="value">{{value || '0'}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconName: String,
    label: String,
    value: [String, Number],
    iconOuterColor: String,
    iconColor: String
  }
}
</script>

<style lang="scss" scoped>
.icon-data {
  display: flex;
  align-items: center;
  .icon-box {
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    margin-right: 20px;
    border-radius: 6px;
    .iconfont {
      font-size: 24px;
    }
  }
  .label-value {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .value {
    font-size: 35px;
    line-height: 49px;
    font-weight: 500;
  }
}
</style>